<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del" @execute="execute" @print="print"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[4586]')" name="0">
                        <wTable
                                id="xpane-0"
                                :data="dataSet"
                                :loading="loading"
                                queryData="IssProSOCollecIssueHeadViewInfo"
                                :filter_language="['order_status_name','negative_flag','verify_type']"
                                :filter_date="['create_time','modify_time','finance_date']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2255]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="po_code" :label="$t('getapi[4283]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_status_name" :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1287]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[6772]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[6773]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[409]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[734]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[1864]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4470]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="verify_type" :label="$t('getapi[6774]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[6775]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1422]')" name="1">
                        <wTable
                                id="xpane-1"
                                :data="dataSet1"
                                :loading="loading"
                                queryData="IssProSOCollecIssueHeadViewInfo"
                                :filter_language="['order_status_name','negative_flag','verify_type']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable1"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet1"
                                ref="singleTable1"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight-reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange1"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2255]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="po_code" :label="$t('getapi[4283]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_status_name" :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1287]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[6772]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[6773]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[409]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[734]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[1864]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4470]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="verify_type" :label="$t('getapi[6774]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[6775]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2408]')" name="2">
                        <wTable
                                id="xpane-2"
                                :data="dataSet2"
                                :loading="loading"
                                queryData="IssProSOCollecIssueHeadViewInfo"
                                :filter_language="['order_status_name','negative_flag','verify_type']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable2"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet2"
                                ref="singleTable2"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight-reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange2"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2255]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="po_code" :label="$t('getapi[4283]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_status_name" :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1287]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[6772]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[6773]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[409]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[734]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[1864]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4470]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="verify_type" :label="$t('getapi[6774]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[6775]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" @click="excuteAccount" :disabled="!btn.excuteAccount">{{$t('getapi[2106]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="getNegativeBillInfo" :disabled="!btn.getNegativeBillInfo">{{
                            $t('getapi[4572]') }}
                        </el-button>
                    </div>
                    <div style="width:850px;min-width:850px">
                        <table>
                        <tr>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[2255]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.order_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[410]') }}</td>
                            <td style="width:100px;min-width:100px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.create_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[135]') }}</td>
                            <td style="width:120px;min-width:120px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.create_time" style="width:100%"  :readonly="true" class="readO"></el-input>
                                <!-- <el-date-picker v-model="dataDetail.Head.create_time" type="date" size="mini"
                                                style="width:100%" :disabled="true"></el-date-picker> -->
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[552]') }}</td>
                            <td style="width:100px;min-width:100px">
                                <el-input type="text" size="mini" :value="expStatus(dataDetail.Head.order_status)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[6775]') }}</td>
                            <td style="width:100px;min-width:100px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.base_order_no" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4283]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.po_code" :readonly="true" class="readO" v-show="dataDetail.Head.order_status != 0"></el-input>
                                <routejump :urlNo="40" v-show="dataDetail.Head.order_status == 0">
                                <el-input
                                        v-model="dataDetail.Head.po_code"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpocode"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[6773]') }}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.audit_person" v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text"
                                           readonly
                                           size="mini"
                                           class="mcolor"
                                           v-model="dataDetail.Head.audit_person"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(3)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[6772]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.audit_time" type="date" size="mini"
                                                style="width:100%" :readonly="dataDetail.Head.order_status != 0" :class="[dataDetail.Head.order_status != 0?'readO':'mcolor']"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[1862]') }}</td>
                            <td>
                                <el-input type="text" size="mini" :value="expFinanceStatus(dataDetail.Head.finance_status)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>
                                {{ $t('getapi[3705]') }}<el-checkbox  v-model="dataDetail.Head.negative_flag"  :true-label=1 :false-label=0 :readonly="true" class="readO"></el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1523]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.vender_code" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1197]') }}</td>
                            <td colspan="5">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.vender_name" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1857]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.finance_date"   :readonly="true" class="readO"></el-input>
                                <!-- <el-date-picker v-model="dataDetail.Head.finance_date" type="date" size="mini"
                                                style="width:100%" :disabled="true"></el-date-picker> -->
                            </td>
                            <td>{{ $t('getapi[4470]') }}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.regist_person" v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.regist_person"
                                           readonly
                                           size="mini"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(2)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[1864]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.keep_person" v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.keep_person"
                                           readonly
                                           size="mini"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(1)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[143]') }}</td>
                            <td colspan="3">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.remark" ></el-input>
                            </td>
                            <td colspan="3">
                                <el-button type="primary" size="mini"  @click="saveremark">{{ $t('getapi[12128]') }}</el-button>
                            </td>
                        </tr>
                    </table>
                    </div>
                    <el-tabs :tab-position="'top'" type="" style="margin-top: 5px" @tab-click="selectInfo1">
                        <el-tab-pane :label="$t('getapi[2351]')" name="0">
                            <div class="btnnowrap">
                                <el-button type="primary" size="mini" @click="selectmasterpart('')" :disabled="dataDetail.Head.order_status != 0 || dataDetail.Head.negative_flag == 1">{{ $t('getapi[6092]') }}</el-button>
                                <el-button type="primary" size="mini" @click="batchDelMaster" :disabled="!btn.batchDelMaster">{{ $t('getapi[1522]') }}</el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-0"
                                    :data="dataDetail.MastLists"
                                    @selection-change="handleSelectionChange"
                                    :row-class-name="tableRowClassNameMaster"
                                    :highlight-current-row="true"
                                    style="width: 100%; margin-top:3px"
                                    :height="tableHeight - 200"
                                    header-row-class-name="headerclass"
                                    size="mini"
                                    border
                                    ref="singleTable3"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"
                                                 align="right" width="50">
                                </el-table-column>
                                <el-table-column prop="part_code" :label="$t('getapi[112]')" width="120">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input
                                                v-model="scope.row.part_code"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectmasterpart(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="plan_qty" :label="$t('getapi[6776]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="unit_qty" :label="$t('getapi[6777]')" align="right"></el-table-column>
                                <el-table-column prop="actually_avg_qty" :label="$t('getapi[4517]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.actually_avg_qty"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="qty_onhand" :label="$t('getapi[2920]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="iss_line_id" :label="$t('getapi[4284]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="create_qty" :label="$t('getapi[4523]')" align="right"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[2200]')" name="1">
                            <div class="btnnowrap">
                                <el-button type="primary" size="mini" @click="selectassistpart('')" :disabled="dataDetail.Head.order_status != 0 || dataDetail.Head.negative_flag == 1">{{$t('getapi[6092]')}}</el-button>
                                <el-button type="primary" size="mini" @click="batchDelAssist" :disabled="!btn.batchDelAssist">{{ $t('getapi[1522]') }}</el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-1"
                                    :data="dataDetail.AssLists"
                                    @selection-change="handleSelectionChange1"
                                    :row-class-name="tableRowClassNameAssist"
                                    :highlight-current-row="true"
                                    style="width: 100%; margin-top:3px"
                                    :height="tableHeight - 200"
                                    header-row-class-name="headerclass"
                                    size="mini"
                                    border
                                    ref="singleTable4"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"
                                                 align="right" width="50">
                                </el-table-column>
                                <el-table-column prop="part_code" :label="$t('getapi[112]')" width="120">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input
                                                v-model="scope.row.part_code"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectassistpart(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="plan_qty" :label="$t('getapi[6776]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="unit_qty" :label="$t('getapi[6777]')" align="right"></el-table-column>
                                <el-table-column prop="actually_avg_qty" :label="$t('getapi[4517]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.actually_avg_qty" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="assist_actually_avg_qty" :label="$t('getapi[2364]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @change="changeAssistQtyBlue(scope)" @mousewheel.native.prevent v-model="scope.row.assist_actually_avg_qty"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_assist_unit" :label="$t('getapi[130]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="master_assist_rate" :label="$t('getapi[2199]')" align="right"></el-table-column>
                                <el-table-column prop="assist_unit_flag" :label="$t('getapi[6778]')">
                                    <template scope="scope">
                                        <el-checkbox  v-model="scope.row.assist_unit_flag"  :true-label=1 :false-label=0></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="qty_onhand" :label="$t('getapi[2920]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="iss_line_id" :label="$t('getapi[4284]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="create_qty" :label="$t('getapi[4523]')" align="right"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[6779]')" name="2">
                            <div class="btnnowrap">
                                <el-button type="primary" size="mini" @click="selectroutpart('')" :disabled="dataDetail.Head.order_status != 0 || dataDetail.Head.negative_flag == 1">{{$t('getapi[6092]')}}</el-button>
                                <el-button type="primary" size="mini" @click="batchDelRout" :disabled="!btn.batchDelRout">{{ $t('getapi[1522]') }}</el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-2"
                                    :data="dataDetail.NoteLists"
                                    @selection-change="handleSelectionChange2"
                                    :row-class-name="tableRowClassNameRout"
                                    :highlight-current-row="true"
                                    style="width: 100%; margin-top:3px"
                                    :height="tableHeight - 200"
                                    header-row-class-name="headerclass"
                                    size="mini"
                                    border
                                    ref="singleTable5"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"
                                                 align="right" width="50">
                                </el-table-column>
                                <el-table-column prop="part_code" :label="$t('getapi[112]')" width="120">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input
                                                v-model="scope.row.part_code"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectroutpart(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="issue_total_qty" :label="$t('getapi[6776]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="single_unitqty" :label="$t('getapi[6777]')" align="right"></el-table-column>
                                <el-table-column prop="issue_qty" :label="$t('getapi[4517]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.issue_qty"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="invunit" :label="$t('getapi[888]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[6780]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
                                <el-table-column field="itemvernum" :label="$t('getapi[6700]')" sortable align="left" width="150">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.itemvernum" :placeholder="$t('getapi[6700]')" size="mini" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="schedule_no" :label="$t('getapi[4209]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="qty_onhand" :label="$t('getapi[6781]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="iss_line_id" :label="$t('getapi[4284]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="create_qty" :label="$t('getapi[4523]')" align="right"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="IssProSOCollecIssueHeadViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[1044]')" queryData="IssProSOCollecIssueHeadViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--选择外协订单号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/ISS/Out/GeIPOCodePopupDataList'" @callback="getpocode" ref="pocode"></selector>
        <!--选择物料-->
        <selectorvxe :isVisible="false" :isBatch=true :postUrl="'/ISS/Out/GetMasterPartPopupList'" @callback="getmasterpart" ref="masterpart"></selectorvxe>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/ISS/Out/GetMasterPartPopupList'" @callback="getmasterpart" ref="masterpartsigle"></selector>
        <!--选择次物料-->
        <selectorvxe :isVisible="false" :isBatch=true :postUrl="'/ISS/Out/GetAssistPartPopupList'" @callback="getassistpart" ref="assistpart"></selectorvxe>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/ISS/Out/GetMasterPartPopupList'" @callback="getassistpart" ref="assistpartsingle"></selector>
        <!--选择坯料-->
        <selector :isVisible="false" :isBatch=true :isSplitPage=false :postUrl="'/ISS/Out/GetRoutPartPopupList'" @callback="getroutpart" ref="routpart"></selector>
        <selector :isVisible="false" :isBatch=false :isSplitPage=false :postUrl="'/ISS/Out/GetMasterPartPopupList'" @callback="getroutpart" ref="routpartsingle"></selector>
        <!--保管员 记账员-->
        <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getperson" ref="person"></selector>
        <!--选择货位号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetActIssOutMastCPPopupList'" @callback="getcargomaster" ref="cargomaster"></selector>
        <!--选择货位号 次-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetActIssOutAssistCPPopupList'" @callback="getcargoassist" ref="cargoassist"></selector>
        <!--外协发料单号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetActIssOutPopupDataList'" @callback="getorderno" ref="orderno"></selector>
        <el-dialog v-dialogDrag :visible.sync="visProIssueExcute" width="80%" :close-on-click-modal="false" :show-close="false">
            <div style="width:890px">
                <table>
                    <tr>
                        <td style="width:60px">{{$t('getapi[6782]')}}</td>
                        <td style="width:150px;">
                            <!--<el-input type="text" size="mini" v-model="dataDetailExecute.Head.order_no" :disabled="true"></el-input>-->
                            <el-input  type="text" v-model="dataDetailExecute.Head.order_no"
                                       readonly
                                       class="mcolor"
                                       size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectorderno"></i>
                            </el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[4283]') }}</td>
                        <td style="width:150px;">
                            <el-input type="text" size="mini" v-model="dataDetailExecute.Head.po_code" :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[2181]') }}</td>
                        <td style="width:100px;">
                            <el-input type="text" size="mini" v-model="dataDetailExecute.Head.audit_person" :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[4637]') }}</td>
                        <td style="width:150px;">
                            <el-date-picker v-model="dataDetail.Head.audit_time" type="date" size="mini"
                                            style="width:100%" :readonly="true" class="readO"></el-date-picker>
                        </td>
                        <td style="width:100px;"><el-checkbox  v-model="dataDetailExecute.Head.negative_flag"  :true-label=1 :false-label=0 ></el-checkbox>{{ $t('getapi[2096]') }}</td>
                    </tr>
                </table>
            </div>
            <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
                <el-tab-pane :label="$t('getapi[2351]')" name="0">
                    <el-table
                            :data="dataDetailExecute.MastList"
                            :highlight-current-row="true"
                            style="width: 100%; margin-top:3px"
                            :height="tableHeight - 240"
                            size="mini"
                            border
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" align="right" width="50"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="120"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1842]')">
                            <template scope="scope">
                                <el-input  type="text" v-model="scope.row.cargo_position"
                                           readonly
                                           class="mcolor"
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcargomaster(scope)"></i>
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="qty_on_hand" :label="$t('getapi[2240]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="actually_avg_qty" :label="$t('getapi[2242]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="quantity" :label="$t('getapi[2207]')" align="right">
                            <template scope="scope">
                                <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.quantity"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')">
                            <template scope="scope">
                                <el-input size="mini" type="text" v-model="scope.row.batch_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')">
                            <template scope="scope">
                                <el-input size="mini" type="text" v-model="scope.row.sequence_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_code" :label="$t('getapi[2250]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="direction" :label="$t('getapi[2251]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="ipo_line_no" :label="$t('getapi[1740]')" align="right"></el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[4524]')" name="1">
                    <el-table
                            :data="dataDetailExecute.AssistList"
                            :highlight-current-row="true"
                            style="width: 100%; margin-top:3px"
                            :height="tableHeight - 240"
                            size="mini"
                            border
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" align="right" width="50"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="120"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1842]')">
                            <template scope="scope">
                                <el-input  type="text" v-model="scope.row.cargo_position"
                                           readonly
                                           class="mcolor"
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcargoassist(scope)"></i>
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="actually_avg_qty" :label="$t('getapi[2242]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="quantity" :label="$t('getapi[2207]')" align="right">
                            <template scope="scope">
                                <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.quantity"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_actually_avg_qty" :label="$t('getapi[2244]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_trans_qty" :label="$t('getapi[2245]')" align="right">
                            <template scope="scope">
                                <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.assist_trans_qty"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')">
                            <template scope="scope">
                                <el-input size="mini" type="text" v-model="scope.row.batch_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')">
                            <template scope="scope">
                                <el-input size="mini" type="text" v-model="scope.row.sequence_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_assist_unit" :label="$t('getapi[130]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="master_assist_rate" :label="$t('getapi[2199]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_code" :label="$t('getapi[2250]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="direction" :label="$t('getapi[2251]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="ipo_line_no" :label="$t('getapi[1740]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="receive_time" :label="$t('getapi[2100]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="expiry_date" :label="$t('getapi[225]')"></el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[6779]')" name="2">
                    <el-table
                            :data="dataDetailExecute.NoteList"
                            :highlight-current-row="true"
                            style="width: 100%; margin-top:3px"
                            :height="tableHeight - 240"
                            size="mini"
                            border
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" align="right" width="50"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="120"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="shop_position_code" :label="$t('getapi[1120]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="pos_qty" :label="$t('getapi[6783]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="invunit" :label="$t('getapi[888]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')">
                            <template scope="scope">
                                <el-input size="mini" type="text" v-model="scope.row.batch_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')">
                            <template scope="scope">
                                <el-input size="mini" type="text" v-model="scope.row.sequence_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="issue_qty" :label="$t('getapi[2242]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="qty" :label="$t('getapi[4591]')" align="right">
                            <template scope="scope">
                                <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.qty"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="ipo_line_no" :label="$t('getapi[4284]')"  align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[2197]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[6784]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[4286]')" align="right"></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visProIssueExcute = false" :disabled="!btn.closeExecute">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="executeSave" :disabled="!btn.executeSave" size="mini">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visDetailPrintType" width="15%" :close-on-click-modal="false">
            <el-form>
                <el-form-item>
                    <div v-for="(item, index) in dataPrint" :key="index">
                        <el-form-item>
                            <el-radio v-model="radio" :label="item.Num" @change="(val)=>{changePrint(val,item.Code)}">{{item.Name}}</el-radio>
                        </el-form-item>
                    </div>
                </el-form-item>
            </el-form>
            <!--<table v-if="userData.Login_DB.toUpperCase() == 'MY'">
                <tr>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="0">美宇(有价格)</el-radio>
                    </td>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="1">锐拓(有价格)</el-radio>
                    </td>
                </tr>
                <tr>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="3">美宇(无价格)</el-radio>
                    </td>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="4">锐拓(无价格)</el-radio>
                    </td>
                </tr>
            </table>
            <table v-if="userData.Login_DB.toUpperCase() != 'MY'">
                <tr>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="0">{{$t('getapi[6497]')}}</el-radio>
                    </td>
                    <td style="width:100px">
                        <el-radio v-model="print_size" label="1">{{$t('getapi[6498]')}}</el-radio>
                    </td>
                </tr>
            </table>-->
            <span slot="footer" class="dialog-footer">
				<el-button @click="visDetailPrintType = false" size="mini">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmPrint" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'issueoutview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('issueoutview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('issueoutview1'), // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('issueoutview2'), // 当前页数据量
                total2: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                dataDetail:{
                    Head:{},
                    MastLists: [],
                    AssLists:[],
                    NoteLists:[],
                },
                oldDataDetail: '',
                SignList: [],
                selectData: [],
                selectData1: [],
                selectData2: [],
                btn:{
                    batchDelMaster: false,
                    batchDelAssist: false,
                    batchDelRout: false,
                    excuteAccount: false,
                    getNegativeBillInfo: false,
                    closeExecute: true,
                    executeSave: true,
                },
                rowindex: -1,
                dataDetailLineNo: 1,
                rowindexmaster: -1,
                rowindexassist: -1,
                rowindexrout: -1,
                oneormoremaster: 1,
                oneormoreassist: 1,
                oneormorerout: 1,
                visProIssueExcute: false,
                dataDetailExecute: {
                    Head:{},
                    MastList: [],
                    AssistList:[],
                    NoteList:[],
                },
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                RightSelectIndex:'0',
                visDetailPrintType: false,
                dataPrint: [], //打印模板
                tempname:'',
                radio: '0',
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
                scrollTop5:0,
            };
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'issrelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataDetail: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(that.RightSelectIndex)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('issueoutview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.srType = Array.methods.getSrType();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                that.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                },false)
                that.$refs.singleTable5.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop5 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                    this.$refs.singleTable4.bodyWrapper.scrollTop =this.scrollTop4;
                    this.$refs.singleTable5.bodyWrapper.scrollTop =this.scrollTop5;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1044]"),this.$t("getapi[13]"));
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('IssProSOCollecIssueHeadViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            tableRowClassNameMaster({ row, rowIndex }) {
                let that = this
                row.index = rowIndex;
            },
            tableRowClassNameAssist({ row, rowIndex }) {
                let that = this
                row.index = rowIndex;
            },
            tableRowClassNameRout({ row, rowIndex }) {
                let that = this
                row.index = rowIndex;
                if (row.issue_qty > row.qty_onhand) {
                    return 'red';
                }
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                console.log('权限' + that.$limits.authority('plv2', 133, 1))
                console.log('权限、' + that.$limits.authority('plv3', 133, 1))
                if(!this.$limits.menuvisible("plv2", 133, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 132, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 133, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 133, 1) == 2) {
                        if (that.$limits.authority('plv3', 133,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 133,1) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                if(that.dataDetail.Head.order_status == 0){
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,print');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 133, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                if(that.dataDetail.Head.order_status == 0){
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,print');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            }
                        }
                    }
                }
                if(that.dataDetail.Head.order_status == 0 && that.dataDetail.Head.order_no != ''){
                    if(that.$limits.authority('plv2', 144, 1) > 0 && that.$limits.authority('plv3', 144, 1) > 0){
                        that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                    } else {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
                that.btn.excuteAccount = false
                that.btn.getNegativeBillInfo = false
                if(!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no) && that.dataDetail.Head.order_status == 1){
                    if(that.dataDetail.Head.finance_status <= 0){
                        that.btn.excuteAccount = true
                    }
                }
                if(!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no) && that.dataDetail.Head.order_status == 1){
                    that.btn.getNegativeBillInfo = true
                }
                that.btn.batchDelMaster = false
                that.btn.batchDelAssist = false
                that.btn.batchDelRout = false
                if (that.$limits.authority('plv2', 133, 1) == 2) {
                    if (that.$limits.authority('plv3', 133, 1) == 1 || that.$limits.authority('plv3', 133, 1) == 2) {
                        if(that.dataDetail.Head.order_status == 0){
                            if(that.selectData.length > 0){
                                that.btn.batchDelMaster = true
                            }
                            if(that.selectData1.length > 0){
                                that.btn.batchDelAssist = true
                            }
                            if(that.selectData2.length > 0){
                                that.btn.batchDelRout = true
                            }
                        }
                    }
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                console.log("测试11");
                clearTimeout(that.timeId)
                console.log("测试22");
                if(!that.iscontinuedblclick){
                    return
                }                
                console.log("测试33");
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('issueoutview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('issueoutview1',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.$http.savePageSize('issueoutview2',val)
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndex)
                });
            },
            selectInfo1(tab, event) {
                let that = this;
                that.RightSelectIndex = tab.name;
                that.$nextTick(function(){
                    that.$processdata.initForm(that.RightSelectIndex)
                });
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'IssProSOCollecIssueHeadViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            print(){
                let that = this;
                let parm = {
                    Code:'pro_so_collecissue_head_iss'
                }
                that.$http.urlpost('/Basic/GetPrintTemplates', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent !=null && res.DataContent.length > 0){
                            that.visDetailPrintType = true
                            that.dataPrint = res.DataContent
                        } else {
                            if(that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){ return; }
                            that.$refs.SetBtn.SetOneBtnEnable('print', false);
                            that.loading = true;
                            let parm = {
                                po_no: that.dataDetail.Head.order_no,
                                TemplateName: '14委外发料单.xlsx'
                            };
                            that.$http.urlpost('/Print/WWFPrint', parm, function (res) {
                                that.$refs.SetBtn.SetOneBtnEnable('print', true);
                                if (res.Success == 1) {
                                    let hrefurl = res.Key;
                                    window.open(hrefurl);
                                }
                                that.loading = false;
                            });
                        }
                    }
                });
            },
            changePrint(val,code){
                let that = this
                that.tempname = code
            },
            confirmPrint(){
                let that = this
                if(that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){
                    return;
                }
                that.loading = true;
                let templatename = that.tempname
                let parm = {
                    po_no: that.dataDetail.Head.order_no,
                    TemplateName: templatename
                };
                that.$http.urlpost('/Print/WWFPrint', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('print', true);
                    if (res.Success == 1) {
                        that.visDetailPrintType = false
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
             /*print() {
            //判断状态
            let that = this;
            if(that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){ return; }
            that.$refs.SetBtn.SetOneBtnEnable('print', false);
            that.loading = true;
            let parm = {
                po_no: that.dataDetail.Head.order_no,
                TemplateName: '14委外发料单.xlsx'
            };
            that.$http.urlpost('/Print/WWPrint', parm, function (res) {
            that.$refs.SetBtn.SetOneBtnEnable('print', true);
            if (res.Success == 1) {
            let hrefurl = res.Key;
            window.open(hrefurl);
            } 
            that.loading = false;
            });
            },*/
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/ISS/Out/IssOutViewList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.order_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 133, 1)){
                        return
                    }
                    let datacopy = that.dataDetail;
                    for (let i = 0; i < datacopy.MastLists.length; i++) {
                        delete datacopy.MastLists[i]['index'];
                    }
                    for (let i = 0; i < datacopy.AssLists.length; i++) {
                        delete datacopy.AssLists[i]['index'];
                    }
                    for (let i = 0; i < datacopy.NoteLists.length; i++) {
                        delete datacopy.NoteLists[i]['index'];
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.order_no
                                that.getDetail(row.order_no)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.SelectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                }
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.order_no
                        that.getDetail(row.order_no)
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.MastLists.length; i++) {
                    delete datacopy.MastLists[i]['index'];
                }
                for (let i = 0; i < datacopy.AssLists.length; i++) {
                    delete datacopy.AssLists[i]['index'];
                }
                for (let i = 0; i < datacopy.NoteLists.length; i++) {
                    delete datacopy.NoteLists[i]['index'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 0
                that.code = ''
                let date = Common.methods.getDate()
                that.dataDetail.Head = {
                    order_no:'',
                    order_status:0,
                    order_status_name:'生成',
                    coll_sign:'',
                    boardspecial_flag:0,
                    finance_status:-1,
                    finance_date:'',
                    issue_dept:'',
                    create_person:'',
                    create_time:'',
                    modify_person:'',
                    modify_time:'',
                    audit_person:'',
                    audit_time:'',
                    regist_person:that.user,
                    keep_person:that.user,
                    negative_flag:0,
                    base_order_no:'',
                    remark:'',
                    po_code:'',
                    vender_code:'',
                    vender_name:'',
                    verify_type:0,
                    order_type:0,
                    concurrent_time:'',
                    vender_call:'',
                    vender_fax:''
                }
                that.dataDetail.MastLists = []
                that.dataDetail.AssLists = []
                that.dataDetail.NoteLists = []
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                if(that.addoredit == 0){
                    that.add()
                } else {
                    that.getDetail(that.code)
                }
                that.getView();*/
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.MastLists.length; i++) {
                    delete datacopy.MastLists[i]['index'];
                }
                for (let i = 0; i < datacopy.AssLists.length; i++) {
                    delete datacopy.AssLists[i]['index'];
                }
                for (let i = 0; i < datacopy.NoteLists.length; i++) {
                    delete datacopy.NoteLists[i]['index'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 0){
                                that.getView();
                                that.confirmAdd()
                            } else {
                                that.getView();
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/Out/IssOutViewExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "IssProSOCollecIssueHeadViewInfo",
                    fromname: that.$t('getapi[1044]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail
                parm.LangType = that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/ISS/Out/IssOutSaveData', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            saveremark(){
                let that = this;
                that.loading = true;
                let parm = that.dataDetail
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/ISS/Out/UpdateRemark', parm, function(res) {
                    that.loading = false;
                    if (res.Success == 1) {                        
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                    
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/ISS/Out/GetIssOutBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        console.log(that.oldDataDetail)
                        that.authority();
                        that.btnauthority()
                    }
                    loadingInstance.close()
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange1(val){
                let that = this;
                that.selectData1 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData1.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange2(val){
                let that = this;
                that.selectData2 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData2.push(val[i]);
                }
                that.btnauthority()
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no : that.dataDetail.Head.order_no,
                            modify_time:that.dataDetail.Head.modify_time
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/ISS/Out/DelIssOutBill', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //获取采购订单
            selectpocode() {
                let that = this;
                that.$refs.pocode.clearInput(true);
            },
            // 获取订单信息
            getpocode(data) {
                let that = this;
                console.log(data)
                that.dataDetail.Head.po_code = data.ipo_code
                that.dataDetail.Head.vender_code = data.vender_code
                that.dataDetail.Head.vender_name = data.vender_name
            },
            batchDel(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            modify_date: that.dataDetail.Head.modify_date,
                            iscontinue: 0,
                            Lists: []
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.Lists.splice(that.selectData[i].index, 1);
                            if(that.selectData[i].exclusively_id!="" && that.selectData[i].exclusively_id!=0){
                                let datatmp = {
                                    exclusively_id:that.selectData[i].exclusively_id,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        if(parm.Lists.length>0){
                            that.$http.urlpost('/ISS/Receive/DelIssReceiveRows', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                } else if(res.Success == 2){
                                    that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                        confirmButtonText: that.$t('getapi[1146]'),
                                        cancelButtonText: that.$t('getapi[2054]'),
                                        type: 'warning'
                                    })
                                        .then(() => {
                                            parm.iscontinue = 1
                                            that.$http.urlpost('/ISS/Receive/DelIssReceiveRows', parm, function (res1) {
                                                if (res1.Success == 1) {
                                                    that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                                    if (that.code != '') {
                                                        that.getDetail(that.code);
                                                    }
                                                }
                                            })
                                        })
                                        .catch(() => {
                                            this.$message({
                                                type: 'info',
                                                message: that.$t('getapi[6096]')
                                            });
                                        });
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 执行记账
            excuteAccount(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    modify_date: that.dataDetail.Head.modify_date
                }
                that.$http.urlpost('/ISS/Out/UpdateFinanceStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code);
                    }
                })
            },
            selectperson(val){
                let that = this;
                that.personType = val
                that.$refs.person.clearInput(true);
            },
            getperson(data){
                let that = this
                console.log(data)
                if(that.personType == 1){
                    that.dataDetail.Head.keep_person = data.name
                } else if(that.personType == 2){
                    that.dataDetail.Head.regist_person = data.name
                } else if(that.personType == 3){
                    that.dataDetail.Head.audit_person = data.name
                }
            },
            selectmasterpart(val){
                let that = this
                that.rowindexmaster = val.$index
                let param = {
                    ipo_code: that.dataDetail.Head.po_code,
                    base_order_no: that.dataDetail.Head.base_order_no,
                    negative_flag: that.dataDetail.Head.negative_flag
                }
                if(val == ''){
                    that.oneormoremaster = 1
                    that.$refs.masterpart.clearInput(true, param);
                } else {
                    that.oneormoremaster = 2
                    that.$refs.masterpartsingle.clearInput(true, param);
                }
            },
            getmasterpart(data){
                let that = this
                console.log(data)
                if(that.oneormoremaster == 1){
                    let arr = data.filter(item => {
                        return that.dataDetail.MastLists.every(item2 => {
                            return (item.part_code+item.part_version) != (item2.part_code+item.part_version);
                        });
                    });
                    data = arr;
                    for(let i = 0;i<data.length;i++){
                        that.dataDetail.MastLists = [...that.dataDetail.MastLists,{
                            exclusively_id:'',
                            relation_order_no:'',
                            line_no:that.getMaxLineNo(),
                            part_code:data[i].part_code,
                            part_version:data[i].part_version,
                            unit_qty:data[i].unit_qty,
                            s_group_qty:0,
                            part_name:data[i].part_name,
                            part_spec:data[i].part_spec,
                            part_model:'',
                            so_code:data[i].so_code,
                            routing_sequence_no:0,
                            routing_desc:'',
                            measure_unit:data[i].part_master_unit,
                            plan_qty:data[i].issue_total_qty,
                            actually_avg_qty:data[i].actually_avg_qty,
                            unit_price:0,
                            line_net_total_amount:0,
                            line_remark:'',
                            po_line_id:data[i].po_line_id,
                            assist_actually_avg_qty:0,
                            issue_material_unit:0,
                            issue_material_amount:0,
                            issue_man_unit:0,
                            issue_man_amount:0,
                            issue_charge_unit:0,
                            issue_charge_amount:0,
                            item_code:'',
                            workcenter_code:'',
                            iss_line_id:data[i].iss_line_id,
                            qty_onhand:data[i].qty_onhand,
                            create_qty:'',
                            part_assist_unit:'',
                            master_assist_rate:0,
                            assist_unit_flag:0,
                            workproc_name:''
                        }]
                    }
                } else {
                    that.dataDetail.MastLists[that.rowindexmaster].exclusively_id = ''
                    that.dataDetail.MastLists[that.rowindexmaster].relation_order_no='',
                    that.dataDetail.MastLists[that.rowindexmaster].part_code=data.part_code,
                    that.dataDetail.MastLists[that.rowindexmaster].part_version=data.part_version,
                    that.dataDetail.MastLists[that.rowindexmaster].unit_qty=data.unit_qty,
                    that.dataDetail.MastLists[that.rowindexmaster].s_group_qty=0,
                    that.dataDetail.MastLists[that.rowindexmaster].part_name=data.part_name,
                    that.dataDetail.MastLists[that.rowindexmaster].part_spec=data.part_spec,
                    that.dataDetail.MastLists[that.rowindexmaster].part_model='',
                    that.dataDetail.MastLists[that.rowindexmaster].so_code=data.so_code,
                    that.dataDetail.MastLists[that.rowindexmaster].routing_sequence_no=0,
                    that.dataDetail.MastLists[that.rowindexmaster].routing_desc='',
                    that.dataDetail.MastLists[that.rowindexmaster].measure_unit=data.part_master_unit,
                    that.dataDetail.MastLists[that.rowindexmaster].plan_qty=data.issue_total_qty,
                    that.dataDetail.MastLists[that.rowindexmaster].actually_avg_qty=data.actually_avg_qty,
                    that.dataDetail.MastLists[that.rowindexmaster].unit_price=0,
                    that.dataDetail.MastLists[that.rowindexmaster].line_net_total_amount=0,
                    that.dataDetail.MastLists[that.rowindexmaster].line_remark='',
                    that.dataDetail.MastLists[that.rowindexmaster].po_line_id=data.po_line_id,
                    that.dataDetail.MastLists[that.rowindexmaster].assist_actually_avg_qty=0,
                    that.dataDetail.MastLists[that.rowindexmaster].issue_material_unit=0,
                    that.dataDetail.MastLists[that.rowindexmaster].issue_material_amount=0,
                    that.dataDetail.MastLists[that.rowindexmaster].issue_man_unit=0,
                    that.dataDetail.MastLists[that.rowindexmaster].issue_man_amount=0,
                    that.dataDetail.MastLists[that.rowindexmaster].issue_charge_unit=0,
                    that.dataDetail.MastLists[that.rowindexmaster].issue_charge_amount=0,
                    that.dataDetail.MastLists[that.rowindexmaster].item_code='',
                    that.dataDetail.MastLists[that.rowindexmaster].workcenter_code='',
                    that.dataDetail.MastLists[that.rowindexmaster].iss_line_id=data.iss_line_id,
                    that.dataDetail.MastLists[that.rowindexmaster].qty_onhand=data.qty_onhand,
                    that.dataDetail.MastLists[that.rowindexmaster].create_qty='',
                    that.dataDetail.MastLists[that.rowindexmaster].part_assist_unit='',
                    that.dataDetail.MastLists[that.rowindexmaster].master_assist_rate=0,
                    that.dataDetail.MastLists[that.rowindexmaster].assist_unit_flag=0,
                    that.dataDetail.MastLists[that.rowindexmaster].workproc_name=''
                }
                for(let i = 0 ;i< that.dataDetail.MastLists.length;i++){
                    let parm = {
                        order_no: that.dataDetail.Head.order_no,
                        ipo_code: that.dataDetail.Head.po_code,
                        so_code: that.dataDetail.MastLists[i].so_code,
                        part_code: that.dataDetail.MastLists[i].part_code,
                        part_version: that.dataDetail.MastLists[i].part_version
                    }
                    that.$http.urlpost('/ISS/Out/GetSetCreateQty', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataDetail.MastLists[i].create_qty = res.DataContent
                        }
                    })
                }
            },
            batchDelMaster() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            List: []
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.MastLists.splice(that.selectData[i].index, 1);
                            if(that.selectData[i].exclusively_id!=""){
                                let datatmp = {
                                    exclusively_id:that.selectData[i].exclusively_id,
                                }
                                parm.List.push(datatmp);
                            }
                        }
                        if(parm.List.length>0){
                            that.$http.urlpost('/ISS/Out/DelIssOutMastRows', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            selectassistpart(val){
                let that = this
                that.rowindexassist = val.$index
                let param = {
                    ipo_code: that.dataDetail.Head.po_code,
                    base_order_no: that.dataDetail.Head.base_order_no,
                    negative_flag: that.dataDetail.Head.negative_flag
                }
                if(val == ''){
                    that.oneormoreassist = 1
                    that.$refs.assistpart.clearInput(true, param);
                } else {
                    that.oneormoreassist = 2
                    that.$refs.assistpartsingle.clearInput(true, param);
                }
            },
            getassistpart(data){
                let that = this
                console.log(data)
                if(that.oneormoreassist == 1){
                    let arr = data.filter(item => {
                        return that.dataDetail.AssLists.every(item2 => {
                            return (item.part_code+item.part_version) != (item2.part_code+item.part_version);
                        });
                    });
                    data = arr;
                    for(let i = 0;i<data.length;i++){
                        that.dataDetail.AssLists = [...that.dataDetail.AssLists,{
                            exclusively_id:'',
                            relation_order_no:'',
                            line_no:that.getMaxLineNo(),
                            part_code:data[i].part_code,
                            part_version:data[i].part_version,
                            unit_qty:data[i].unit_qty,
                            s_group_qty:0,
                            part_name:data[i].part_name,
                            part_spec:data[i].part_spec,
                            part_model:'',
                            so_code:data[i].so_code,
                            routing_sequence_no:0,
                            routing_desc:'',
                            measure_unit:data[i].part_master_unit,
                            plan_qty:data[i].issue_total_qty,
                            actually_avg_qty:data[i].actually_avg_qty,
                            unit_price:0,
                            line_net_total_amount:0,
                            line_remark:'',
                            po_line_id:data[i].po_line_id,
                            assist_actually_avg_qty:data[i].assist_actually_avg_qty,
                            issue_material_unit:0,
                            issue_material_amount:0,
                            issue_man_unit:0,
                            issue_man_amount:0,
                            issue_charge_unit:0,
                            issue_charge_amount:0,
                            item_code:'',
                            workcenter_code:'',
                            iss_line_id:data[i].iss_line_id,
                            qty_onhand:data[i].qty_onhand,
                            create_qty:0,
                            part_assist_unit:data[i].part_assist_unit,
                            master_assist_rate:data[i].master_assist_rate,
                            assist_unit_flag:data[i].assist_unit_flag == true?1:0,
                            workproc_name:''
                        }]
                    }
                } else {
                    that.dataDetail.AssLists[that.rowindexassist].exclusively_id = ''
                    that.dataDetail.AssLists[that.rowindexassist].relation_order_no='',
                    that.dataDetail.AssLists[that.rowindexassist].part_code=data.part_code,
                    that.dataDetail.AssLists[that.rowindexassist].part_version=data.part_version,
                    that.dataDetail.AssLists[that.rowindexassist].unit_qty=data.unit_qty,
                    that.dataDetail.AssLists[that.rowindexassist].s_group_qty=0,
                    that.dataDetail.AssLists[that.rowindexassist].part_name=data.part_name,
                    that.dataDetail.AssLists[that.rowindexassist].part_spec=data.part_spec,
                    that.dataDetail.AssLists[that.rowindexassist].part_model='',
                    that.dataDetail.AssLists[that.rowindexassist].so_code=data.so_code,
                    that.dataDetail.AssLists[that.rowindexassist].routing_sequence_no=0,
                    that.dataDetail.AssLists[that.rowindexassist].routing_desc='',
                    that.dataDetail.AssLists[that.rowindexassist].measure_unit=data.part_master_unit,
                    that.dataDetail.AssLists[that.rowindexassist].plan_qty=data.issue_total_qty,
                    that.dataDetail.AssLists[that.rowindexassist].actually_avg_qty=data.actually_avg_qty,
                    that.dataDetail.AssLists[that.rowindexassist].unit_price=0,
                    that.dataDetail.AssLists[that.rowindexassist].line_net_total_amount=0,
                    that.dataDetail.AssLists[that.rowindexassist].line_remark='',
                    that.dataDetail.AssLists[that.rowindexassist].po_line_id=data.po_line_id,
                    that.dataDetail.AssLists[that.rowindexassist].assist_actually_avg_qty=data.assist_actually_avg_qty,
                    that.dataDetail.AssLists[that.rowindexassist].issue_material_unit=0,
                    that.dataDetail.AssLists[that.rowindexassist].issue_material_amount=0,
                    that.dataDetail.AssLists[that.rowindexassist].issue_man_unit=0,
                    that.dataDetail.AssLists[that.rowindexassist].issue_man_amount=0,
                    that.dataDetail.AssLists[that.rowindexassist].issue_charge_unit=0,
                    that.dataDetail.AssLists[that.rowindexassist].issue_charge_amount=0,
                    that.dataDetail.AssLists[that.rowindexassist].item_code='',
                    that.dataDetail.AssLists[that.rowindexassist].workcenter_code='',
                    that.dataDetail.AssLists[that.rowindexassist].iss_line_id=data.iss_line_id,
                    that.dataDetail.AssLists[that.rowindexassist].qty_onhand=data.qty_onhand,
                    that.dataDetail.AssLists[that.rowindexassist].create_qty=0,
                    that.dataDetail.AssLists[that.rowindexassist].part_assist_unit=data.part_assist_unit,
                    that.dataDetail.AssLists[that.rowindexassist].master_assist_rate=data.master_assist_rate,
                    that.dataDetail.AssLists[that.rowindexassist].assist_unit_flag=(data.assist_unit_flag == true ? 1 : 0),
                    that.dataDetail.AssLists[that.rowindexassist].workproc_name=''
                }
                for(let i = 0 ;i< that.dataDetail.AssLists.length;i++){
                    let parm = {
                        order_no: that.dataDetail.Head.order_no,
                        ipo_code: that.dataDetail.Head.po_code,
                        so_code: that.dataDetail.AssLists[i].so_code,
                        part_code: that.dataDetail.AssLists[i].part_code,
                        part_version: that.dataDetail.AssLists[i].part_version
                    }
                    that.$http.urlpost('/ISS/Out/GetSetCreateQty', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataDetail.AssLists[i].create_qty = res.DataContent
                        }
                    })
                }
            },
            batchDelAssist() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            List: []
                        };
                        for (let i = that.selectData1.length - 1; i >= 0; i--) {
                            that.dataDetail.AssLists.splice(that.selectData1[i].index, 1);
                            if(that.selectData1[i].exclusively_id!=""){
                                let datatmp = {
                                    exclusively_id:that.selectData1[i].exclusively_id,
                                }
                                parm.List.push(datatmp);
                            }
                        }
                        if(parm.List.length>0){
                            that.$http.urlpost('/ISS/Out/DelIssOutAssistRows', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            selectroutpart(val){
                let that = this
                that.rowindexrout = val.$index
                let param = {
                    ipo_code: that.dataDetail.Head.po_code,
                    base_order_no: that.dataDetail.Head.base_order_no,
                    negative_flag: that.dataDetail.Head.negative_flag
                }
                if(val == ''){
                    that.oneormorerout = 1
                    that.$refs.routpart.clearInput(true, param);
                } else {
                    that.oneormorerout = 2
                    that.$refs.routpartsingle.clearInput(true, param);
                }
            },
            getroutpart(data){
                let that = this
                console.log(data)
                if(that.oneormorerout == 1){
                    let arr = data.filter(item => {
                        return that.dataDetail.NoteLists.every(item2 => {
                            return (item.part_code+item.part_version) != (item2.part_code+item.part_version);
                        });
                    });
                    data = arr;
                    for(let i = 0;i<data.length;i++){
                        that.dataDetail.NoteLists = [...that.dataDetail.NoteLists,{
                            exclusively_id:0,
                            relation_order_no:'',
                            line_no:that.getMaxLineNo(),
                            part_code:data[i].part_code,
                            part_version:data[i].part_version,
                            workproc_name:data[i].workproc_name,
                            part_name:data[i].part_name,
                            part_spec:data[i].part_spec,
                            invunit:data[i].part_master_unit,
                            single_unitqty:data[i].unit_qty,
                            s_group_qty:0,
                            issue_qty:data[i].actually_avg_qty,
                            issue_assist_qty:0,
                            ipo_line_id:data[i].po_line_id,
                            so_code:data[i].so_code,
                            schedule_no:data[i].schedule_no,
                            issue_material_unit:0,
                            issue_material_amount:0,
                            issue_man_unit:0,
                            issue_man_amount:0,
                            issue_charge_unit:0,
                            issue_charge_amount:0,
                            unit_price:0,
                            line_net_total_amount:0,
                            qty_onhand:data[i].qty_onhand,
                            create_qty:0,
                            issue_total_qty:data[i].issue_total_qty,
                            iss_line_id:data[i].iss_line_id,
                            part_assist_unit:'',
                            master_assist_rate:0,
                            assist_unit_flag:0
                        }]
                    }
                } else {
                    that.dataDetail.NoteLists[that.rowindexrout].exclusively_id = ''
                    that.dataDetail.NoteLists[that.rowindexrout].relation_order_no='',
                    that.dataDetail.NoteLists[that.rowindexrout].part_code=data.part_code,
                    that.dataDetail.NoteLists[that.rowindexrout].part_version=data.part_version,
                    that.dataDetail.NoteLists[that.rowindexrout].workproc_name=data.workproc_name,
                    that.dataDetail.NoteLists[that.rowindexrout].part_name=data.part_name,
                    that.dataDetail.NoteLists[that.rowindexrout].part_spec=data.part_spec,
                    that.dataDetail.NoteLists[that.rowindexrout].invunit=data.part_master_unit,
                    that.dataDetail.NoteLists[that.rowindexrout].single_unitqty=data.unit_qty,
                    that.dataDetail.NoteLists[that.rowindexrout].s_group_qty=0,
                    that.dataDetail.NoteLists[that.rowindexrout].issue_qty=data.actually_avg_qty,
                    that.dataDetail.NoteLists[that.rowindexrout].issue_assist_qty=0,
                    that.dataDetail.NoteLists[that.rowindexrout].ipo_line_id=data.po_line_id,
                    that.dataDetail.NoteLists[that.rowindexrout].so_code=data.so_code,
                    that.dataDetail.NoteLists[that.rowindexrout].schedule_no=data.schedule_no,
                    that.dataDetail.NoteLists[that.rowindexrout].issue_material_unit=0,
                    that.dataDetail.NoteLists[that.rowindexrout].issue_material_amount=0,
                    that.dataDetail.NoteLists[that.rowindexrout].issue_man_unit=0,
                    that.dataDetail.NoteLists[that.rowindexrout].issue_man_amount=0,
                    that.dataDetail.NoteLists[that.rowindexrout].issue_charge_unit=0,
                    that.dataDetail.NoteLists[that.rowindexrout].issue_charge_amount=0,
                    that.dataDetail.NoteLists[that.rowindexrout].unit_price=0,
                    that.dataDetail.NoteLists[that.rowindexrout].line_net_total_amount=0,
                    that.dataDetail.NoteLists[that.rowindexrout].qty_onhand=data.qty_onhand,
                    that.dataDetail.NoteLists[that.rowindexrout].create_qty=0,
                    that.dataDetail.NoteLists[that.rowindexrout].issue_total_qty=data.issue_total_qty,
                    that.dataDetail.NoteLists[that.rowindexrout].iss_line_id=data.iss_line_id,
                    that.dataDetail.NoteLists[that.rowindexrout].part_assist_unit='',
                    that.dataDetail.NoteLists[that.rowindexrout].master_assist_rate=0,
                    that.dataDetail.NoteLists[that.rowindexrout].assist_unit_flag=0
                    
                }
                for(let i = 0 ;i< that.dataDetail.AssLists.length;i++){
                    let parm = {
                        order_no: that.dataDetail.Head.order_no,
                        ipo_code: that.dataDetail.Head.po_code,
                        so_code: that.dataDetail.NoteLists[i].so_code,
                        part_code: that.dataDetail.NoteLists[i].part_code,
                        part_version: that.dataDetail.NoteLists[i].part_version
                    }
                    that.$http.urlpost('/ISS/Out/GetRoutSetCreateQty', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataDetail.NoteLists[i].create_qty = res.DataContent
                        }
                    })
                }
            },
            batchDelRout() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            List: []
                        };
                        for (let i = that.selectData2.length - 1; i >= 0; i--) {
                            that.dataDetail.NoteLists.splice(that.selectData2[i].index, 1);
                            if(that.selectData2[i].exclusively_id!=""){
                                let datatmp = {
                                    exclusively_id:that.selectData2[i].exclusively_id,
                                }
                                parm.List.push(datatmp);
                            }
                        }
                        if(parm.List.length>0){
                            that.$http.urlpost('/ISS/Out/DelIssOutNoteRows', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 获取行号
            getMaxLineNo()
            {
                let that = this;
                var ReturnInt = 0;
                for (var i = 0; i < that.dataDetail.MastLists.length; i++)
                {
                    if (that.dataDetail.MastLists[i].line_no > ReturnInt)
                    {
                        ReturnInt =that.dataDetail.MastLists[i].line_no;
                    }
                }

                for (var j = 0; j < that.dataDetail.AssLists.length; j++)
                {
                    if (that.dataDetail.AssLists[j].line_no > ReturnInt)
                    {
                        ReturnInt = that.dataDetail.AssLists[j].line_no;
                    }
                }

                for (var k = 0; k < that.dataDetail.NoteLists.length; k++)
                {
                    if (that.dataDetail.NoteLists[k].line_no > ReturnInt)
                    {
                        ReturnInt = that.dataDetail.NoteLists[k].line_no;
                    }
                }
                return ReturnInt + 1;
            },
            // 执行
            execute(){
                let that = this
                that.visProIssueExcute = true
                that.getIssOutBillInfo(that.dataDetail.Head.order_no)
                that.btn.executeSave = true
            },
            // 执行信息获取
            getIssOutBillInfo(code){
                let that = this
                let parm = {
                    Code: code
                }
                that.$http.urlpost('/Inv/Action/GetActIssOutBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        // that.$message.success(res.Msg);
                        that.dataDetailExecute = res.DataContent
                    }
                    else{
                        that.visProIssueExcute = false;
                    }
                })
            },
            // 选择货位
            selectcargomaster(row){
                let that = this;
                that.rowindexcargomaster = row.$index
                that.$refs.cargomaster.clearInput(true);
            },
            getcargomaster(data){
                let that = this
                console.log(data)
                that.dataDetailExecute.MastList[that.rowindexcargomaster].cargo_position = data.cargoposition_code
            },
            selectcargoassist(row){
                let that = this;
                that.rowindexcargoassist = row.$index
                that.$refs.cargoassist.clearInput(true);
            },
            getcargoassist(data){
                let that = this
                console.log(data)
                that.dataDetailExecute.AssistList[that.rowindexcargoassist].cargo_position = data.cargoposition_code
            },
            selectorderno(){
                let that = this;
                that.$refs.orderno.clearInput(true);
            },
            getorderno(data){
                let that = this
                console.log(data)
                that.btn.executeSave = true
                that.dataDetailExecute.Head.order_no = data.order_no
                that.dataDetailExecute.Head.po_code = data.po_code
                that.dataDetailExecute.Head.audit_person = data.audit_person
                that.dataDetailExecute.Head.audit_time = data.audit_time
                that.dataDetailExecute.Head.negative_flag = data.negative_flag
                that.getIssOutBillInfo(that.dataDetailExecute.Head.order_no)
            },
            executeSave(){
                let that = this
                let parm = that.dataDetailExecute
                parm.LangType = that.$processdata.getLang()
                that.btn.executeSave = false
                that.btn.closeExecute = false
                that.$http.urlpost('/Inv/Action/ActIssOutSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    } else {
                        that.btn.executeSave = true
                    }
                    that.btn.closeExecute = true
                })
            },
            expFinanceStatus(val) {
                if (val == 0) {
                    return '审核';
                } else if (val == 1) {
                    return '记账';
                } else if (val == 2) {
                    return '月结';
                } else {
                    return '';
                }
            },
            // 生成红字单
            getNegativeBillInfo(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    modify_time: that.dataDetail.Head.modify_time
                }
                that.$http.urlpost('/ISS/Out/IssOutNegativeBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.dataDetail = res.DataContent
                        that.authority()
                    }
                })
            },
            // 详情次数量改变
            changeAssistQtyBlue(row){
                let that = this
                let index = row.$index
                that.dataDetail.AssLists[index].actually_avg_qty = that.dataDetail.AssLists[index].assist_actually_avg_qty * that.dataDetail.AssLists[index].master_assist_rate
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[941]')//'审核';
                } else {
                    return '';
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 133,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.MastLists.length; i++) {
                    delete datacopy.MastLists[i]['index'];
                }
                for (let i = 0; i < datacopy.AssLists.length; i++) {
                    delete datacopy.AssLists[i]['index'];
                }
                for (let i = 0; i < datacopy.NoteLists.length; i++) {
                    delete datacopy.NoteLists[i]['index'];
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
